<template>
  <v-card flat class="conteneurLead" style="width: 100%;">
    <v-card-title class="primary white--text" style="height: 52px; padding: 0px;">
      <v-btn icon @click="$emit('justCloseDialogConfirm')"><v-icon class="white--text">close</v-icon></v-btn>
      <div class="title tf_title_dialog" v-html="titleDialogConfirm"></div>
    </v-card-title>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-select
            v-model="selectedSection"
            :items="sectionOptions"
            item-text="text"
            item-value="id"
            label="Section"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="versions"
        :loading="loadingData"
        class="elevation-1"
        :rows-per-page-items="[10, 25, 50]"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td @click.stop="openVersion(props.item)">{{ props.item.date }}</td>
            <td @click.stop="openVersion(props.item)">{{ props.item.name }}</td>
            <td @click.stop="openVersion(props.item)">{{ props.item.comment }}</td>
            <td @click.stop="openVersion(props.item)">{{ props.item.who }}</td>
            <td @click.stop="openVersion(props.item)">{{ props.item.llm }}</td>
            <td>{{ props.item['tokens_' + selectedSection] || props.item.tokens || 0 }}</td>
            <td class="text-xs-right">
              <v-btn small flat color="primary" @click.stop="openVersion(props.item)">Voir</v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="showCompareDialog" persistent scrollable max-width="90%">
      <v-card>
        <v-card-title class="primary white--text">
          <v-btn icon dark @click="closeCompareDialog"><v-icon>close</v-icon></v-btn>
          <span class="title">Historique prompt CSAT</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md6 class="pr-3">
              <h3 class="mb-2">Prompt actuel</h3>
              <v-textarea :value="currentPromptValue()" readonly auto-grow rows="12" outline></v-textarea>
            </v-flex>
            <v-flex xs12 md6 class="pl-3">
              <h3 class="mb-2">Version historisee</h3>
              <v-textarea :value="historicPromptValue()" readonly auto-grow rows="12" outline></v-textarea>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="showRenameDialog = true" :disabled="!selectedVersion">Renommer</v-btn>
          <v-btn flat color="error" @click="confirmDeleteVersion" :disabled="!selectedVersion">Supprimer</v-btn>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeCompareDialog">Fermer</v-btn>
          <v-btn color="warning" @click="restoreSelectedSection" :disabled="!selectedVersion">Restaurer section</v-btn>
          <v-btn color="warning" @click="restoreAllSections" :disabled="!selectedVersion">Restaurer tout</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showRenameDialog" max-width="560" persistent>
      <v-card>
        <v-card-title class="headline">Renommer la version</v-card-title>
        <v-card-text>
          <v-text-field v-model="renamePromptName" label="Nom"></v-text-field>
          <v-textarea v-model="renamePromptComment" label="Commentaire" auto-grow rows="4"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="showRenameDialog = false">Annuler</v-btn>
          <v-btn color="primary" :loading="loadingRename" @click="submitRenameVersion">Enregistrer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  props: {
    titleDialogConfirm: {
      type: String,
      default: 'Historique prompt CSAT'
    },
    currentPromptData: {
      type: Object,
      default: () => ({})
    },
    siteKey: {
      type: String,
      default: ''
    },
    sectionOptions: {
      type: Array,
      default: () => ([
        { text: 'Personality', id: 'personality' },
        { text: 'Mission', id: 'environment' },
        { text: 'Regles', id: 'objectif' },
        { text: 'Bloc 4', id: 'communication' }
      ])
    }
  },
  data () {
    return {
      selectedSection: 'personality',
      versions: [],
      loadingData: false,
      selectedVersion: null,
      showCompareDialog: false,
      showRenameDialog: false,
      renamePromptName: '',
      renamePromptComment: '',
      loadingRename: false,
      headers: [
        { text: 'Date', value: 'date' },
        { text: 'Nom', value: 'name' },
        { text: 'Commentaire', value: 'comment' },
        { text: 'Auteur', value: 'who' },
        { text: 'Scenario', value: 'llm' },
        { text: 'Tokens', value: 'tokens' },
        { text: '', value: 'actions', sortable: false }
      ]
    }
  },
  created () {
    this.loadVersions()
  },
  watch: {
    siteKey () {
      this.loadVersions()
    }
  },
  methods: {
    loadVersions () {
      if (!this.siteKey) return
      this.loadingData = true
      this.axios.get('get/prompt_csat_version.php?sitekey=' + this.siteKey)
        .then(response => {
          this.versions = Array.isArray(response.data) ? response.data : []
        })
        .catch(() => {})
        .then(() => {
          this.loadingData = false
        })
    },
    openVersion (item) {
      this.selectedVersion = item
      this.renamePromptName = item && item.name ? item.name : ''
      this.renamePromptComment = item && item.comment ? item.comment : ''
      this.showCompareDialog = true
    },
    closeCompareDialog () {
      this.showCompareDialog = false
      this.selectedVersion = null
      this.showRenameDialog = false
    },
    currentPromptValue () {
      return this.currentPromptData[this.selectedSection] || ''
    },
    historicPromptValue () {
      if (!this.selectedVersion) return ''
      return this.selectedVersion[this.selectedSection] || this.selectedVersion.preview || ''
    },
    restoreSelectedSection () {
      if (!this.selectedVersion) return
      this.$emit('restorePromptSection', this.selectedSection, this.historicPromptValue())
      this.closeCompareDialog()
    },
    restoreAllSections () {
      if (!this.selectedVersion) return
      this.$emit('restoreAllPromptSections', {
        personality: this.selectedVersion.personality || '',
        environment: this.selectedVersion.environment || '',
        objectif: this.selectedVersion.objectif || '',
        communication: this.selectedVersion.communication || ''
      })
      this.closeCompareDialog()
    },
    submitRenameVersion () {
      if (!this.selectedVersion) return
      const dataToPost = new window.FormData()
      dataToPost.append('sitekey', this.siteKey)
      dataToPost.append('prompt_date_raw', this.selectedVersion.date_raw || '')
      dataToPost.append('prompt_user_id', this.selectedVersion.user || '')
      dataToPost.append('prompt_isbackup', this.selectedVersion.is_backup)
      dataToPost.append('prompt_name', this.renamePromptName || '')
      dataToPost.append('prompt_comment', this.renamePromptComment || '')

      this.loadingRename = true
      this.axios.post('post/rename_prompt_csat_version.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
        .then(() => {
          this.showRenameDialog = false
          this.loadVersions()
        })
        .catch(() => {})
        .then(() => {
          this.loadingRename = false
        })
    },
    confirmDeleteVersion () {
      if (!this.selectedVersion) return
      const dataToPost = new window.FormData()
      dataToPost.append('sitekey', this.siteKey)
      dataToPost.append('prompt_date_raw', this.selectedVersion.date_raw || '')
      dataToPost.append('prompt_user_id', this.selectedVersion.user || '')
      dataToPost.append('prompt_isbackup', this.selectedVersion.is_backup)
      this.axios.post('post/delete_prompt_csat_version.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
        .then(() => {
          this.closeCompareDialog()
          this.loadVersions()
        })
        .catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialogVersionPromptCsat.vue